// This mixin contains code that is used for snotify async success and error http generic responses.
export default {
  methods: {
    snotifyHttpError(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of this 2xx
        if (
          error.response.data.hasOwnProperty("MoreInformation") &&
          error.response.data.MoreInformation.length > 0
        ) {
          error.response.data.MoreInformation.forEach((e) => {
            this.$snotify.error(`${e.Error}`.replaceAll("_", "_​"), {
              timeout: 0,
              closeOnClick: true,
              bodyMaxLength: 1000
            });
          });
          // snotify async reject object
          return {
            title: "Error",
            config: {
              closeOnClick: true,
              timeout: 1,
              bodyMaxLength: 1000
            },
          };
        } else {
          // snotify async reject object
          return {
            body: `${error.response.data.UserDescription}`.replaceAll("_", "_​"),
            config: {
              timeout: 0,
              closeOnClick: true,
              bodyMaxLength: 1000
            },
          };
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        // snotify async reject object
        return {
          title: "Error",
          body: "No response recieved.",
          config: {
            timeout: 0,
            closeOnClick: true,
            bodyMaxLength: 1000
          },
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        // snotify async reject object
        return {
          title: "Error",
          body: `${error.message}`.replaceAll("_", "_​"),
          config: {
            timeout: 0,
            closeOnClick: true,
            bodyMaxLength: 1000
          },
        };
      }
    },
  },
};
